var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_330)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7093 11.0623L12.937 6.29001L3.34723 15.8798L8.11949 20.6521L17.7093 11.0623Z",
    fill: "#F1C25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0733 7.69927L16.301 2.927L12.938 6.29L17.7103 11.0623L21.0733 7.69927Z",
    fill: "#27353B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3977 3.83035L15.153 4.07501L19.9253 8.84728L20.1699 8.60262L15.3977 3.83035Z",
    fill: "#006577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0857 5.14237L13.841 5.38702L18.6132 10.1594L18.8578 9.91472L14.0857 5.14237Z",
    fill: "#006577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11998 20.652C8.28898 20.483 8.06998 19.99 7.63098 19.552C7.39588 19.2866 7.08654 19.0977 6.74298 19.01C6.70195 19.0054 6.66371 18.987 6.63461 18.9577C6.60551 18.9284 6.58729 18.8901 6.58298 18.849C6.47467 18.5146 6.28859 18.2106 6.04001 17.962C5.79143 17.7134 5.48743 17.5273 5.15298 17.419C5.11197 17.4148 5.07365 17.3966 5.04449 17.3675C5.01534 17.3383 4.99715 17.3 4.99298 17.259C4.90439 16.9156 4.71532 16.6064 4.44998 16.371C4.00998 15.932 3.51699 15.713 3.34999 15.882L1.19098 22.813L8.11998 20.652Z",
    fill: "#FFF7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.189 22.811L4.117 21.899L2.10001 19.883L1.189 22.811Z",
    fill: "#27353B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.823 2.17701C21.5097 1.86364 21.1377 1.61506 20.7283 1.44546C20.3189 1.27586 19.8801 1.18857 19.437 1.18857C18.9939 1.18857 18.5551 1.27586 18.1457 1.44546C17.7363 1.61506 17.3643 1.86364 17.051 2.17701L16.301 2.92701L21.073 7.70001L21.823 6.95001C22.1365 6.63668 22.3852 6.26464 22.5549 5.85516C22.7246 5.44567 22.812 5.00676 22.812 4.56351C22.812 4.12026 22.7246 3.68135 22.5549 3.27187C22.3852 2.86238 22.1365 2.49034 21.823 2.17701Z",
    fill: "#F1625C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.59f77d8d706aee926de82cb832249816.svg";
export { ForwardRef as ReactComponent };